import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
	name: 'shortDate',
})
export class ShortDate implements PipeTransform {
	transform(date: string | number): string {
		return date && date !== '-' ? moment(date).format('YYYY-MM-DD') : '';
	}
}
